/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_User_MenuInputs */

const en_common_user_menu = /** @type {(inputs: Common_User_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User menu`)
};

const es_common_user_menu = /** @type {(inputs: Common_User_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu de usuario`)
};

/**
* | output |
* | --- |
* | "User menu" |
*
* @param {Common_User_MenuInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_user_menu = /** @type {((inputs?: Common_User_MenuInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_User_MenuInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_user_menu(inputs)
	return es_common_user_menu(inputs)
});